export const config = {
    backendUrl: process.env.REACT_APP_BACKEND_URL,
    pythonBackendUrl: process.env.REACT_APP_PYTHON_BACKEND_URL,
    s3BucketName: process.env.REACT_APP_S3_BUCKET_NAME,
    recaptchaSiteKey: process.env.REACT_APP_SITE_KEY,
    frontendUrl: process.env.REACT_APP_FRONTEND_URL,
    region: process.env.REACT_APP_APP_REGION,
    amplifyConfig: {
        userPoolId: process.env.REACT_APP_USER_POOL_ID,
        userPoolClientId: process.env.REACT_APP_CLIENT_ID,
    }
};